export default "__VITE_ASSET__66b8be48__"